import React from 'react';
import { LeistungslohnVariant } from './types';

interface LeistungslohnVariantToggleProps {
    variant: LeistungslohnVariant;
    onChange: (variant: LeistungslohnVariant) => void;
    className?: string;
}

/** Schlanke Segmented-Control: Mono-Leistungslohn | Team-Leistungslohn */
export const LeistungslohnVariantToggle: React.FC<LeistungslohnVariantToggleProps> = ({
    variant,
    onChange,
    className = '',
}) => {
    const btn = (value: LeistungslohnVariant, label: string) => {
        const active = variant === value;
        const isTeam = value === 'team';
        return (
            <button
                type="button"
                onClick={() => onChange(value)}
                className={`px-4 py-2 text-[10px] font-black uppercase tracking-widest rounded-lg border transition-all ${
                    active
                        ? isTeam
                            ? 'bg-amber-500 text-black border-amber-400 shadow-[0_0_16px_rgba(245,158,11,0.35)]'
                            : 'bg-[#E6C299] text-black border-[#E6C299] shadow-lg'
                        : 'bg-pe-tile-header dark:bg-[#15171e] text-pe-muted dark:text-slate-400 border-pe-border dark:border-slate-700 hover:border-pe-border-strong'
                }`}
            >
                {label}
            </button>
        );
    };

    return (
        <div
            className={`inline-flex items-center gap-2 ${className}`}
            role="group"
            aria-label="Leistungslohn-Variante"
        >
            {btn('mono', 'Mono-Leistungslohn')}
            {btn('team', 'Team-Leistungslohn')}
        </div>
    );
};

export default LeistungslohnVariantToggle;
